export const CHARTER_STOCK_CLASSES_CONTEXT_KEY = ['charterStockClassesContext'] as const;

export type CharterStockClassesContext = {
  selectedFilingId?: string;
  activeFilingId?: string;
};
